export enum ChartType {
  Pie = "pie",
  Heatmap = "heatmap",
  TimeSeries = "line",
  CategorySeries = "category",
  StackedColumn = "stackedColumn",
  Waterfall = "waterfall",
  Mixed = "mixed",
  Scatter = "scatter",
}

export enum LegendAlignment {
  Right = "right",
  Left = "left",
  Top = "top",
  Bottom = "bottom",
}

export enum TodayPlotLine {
  Hide = "hide",
  Basic = "basic",
  Detailed = "detailed",
}

export enum DateType {
  Yearly = "yearly",
  Quarterly = "quarterly",
  Monthly = "monthly",
  Weekly = "weekly",
  Daily = "daily",
  Time = "time",
  MonthlyNoYear = "monthlyNoYear",
}

export enum FinanceSeries {
  Sales = "sales",
  Forecast = "forecast",
  ItemProfit = "itemProfit",
  FutureItemProfit = "futureItemProfit",
  Profit = "profit",
  FutureProfit = "futureProfit",
  ItemPrice = "itemPrice",
  FutureItemPrice = "futureItemPrice",
  Revenue = "revenue",
  FutureRevenue = "futureRevenue",
  GrossMargin = "GrossMargin",
  FutureGrossMargin = "futureGrossMargin",
  DiscountPercentage = "discountPercentage",
  FutureDiscountPercentage = "futureDiscountPercentage",
}
